import { Component, inject } from '@angular/core';
import { FormWrapperComponent } from '../../../ui/form-wrapper/form-wrapper.component';
import { CampaignDetailsService } from '../../../../services/campaign/campaign-details.service';

/** Step 1 summary: name, description and goals as typed. */
@Component({
  selector: 'app-campaign-details-preview',
  standalone: true,
  imports: [FormWrapperComponent],
  templateUrl: './campaign-details-preview.component.html',
  styleUrl: '../campaign-preview.css',
})
export class CampaignDetailsPreviewComponent {
  campaignDetails = inject(CampaignDetailsService);

  get details() {
    return this.campaignDetails.campaignDetails;
  }

  /** Goals with something written in them. */
  get goals(): string[] {
    return (this.details.goals ?? []).filter((goal) => !!String(goal ?? '').trim());
  }
}
